import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as skills from '../../skills'

export const RESOURCE = {
  payload: {
    description:
      'A skill that an employee possesses that can be used to inform future staffing decisions.',
    dimension: skills.RESOURCE.payload,
    level: 0,
    name: 'Skill',
    partialId: PartialId.Standard.create('skill'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
